"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var _1 = __importDefault(require("./"));
var volume_1 = require("./controls/volume");
var VideoContainer = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    height: 100%;\n    width: 100%;\n"], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    height: 100%;\n    width: 100%;\n"])));
var VideoStyled = styled_1.default(_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    height: 100%;\n    display: inline-block;\n    object-fit: fill;\n    pointer-events: none;\n    background: rgb(0, 0, 0, 0);\n"], ["\n    height: 100%;\n    display: inline-block;\n    object-fit: fill;\n    pointer-events: none;\n    background: rgb(0, 0, 0, 0);\n"])));
var Button = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    cursor: pointer;\n    opacity: ", ";\n    transition: opacity ease-out 800ms;\n"], ["\n    position: absolute;\n    top: 6px;\n    right: 6px;\n    cursor: pointer;\n    opacity: ", ";\n    transition: opacity ease-out 800ms;\n"])), function (props) { return (props.isHovered ? 1 : 0.8); });
var speakerClassName = 'giphy-video-overlay-button';
var VolumeButton = function (_a) {
    var muted = _a.muted, toggleMute = _a.toggleMute, mutedByBrowser = _a.mutedByBrowser, isHovered = _a.isHovered;
    return (react_1.default.createElement(Button, { className: speakerClassName, onClick: function (e) {
            e.preventDefault();
            e.stopPropagation();
            toggleMute();
        }, isHovered: isHovered }, muted || mutedByBrowser || !isHovered ? react_1.default.createElement(volume_1.VolumeOffIcon, null) : react_1.default.createElement(volume_1.VolumeOnIcon, null)));
};
var VideoOverlay = function (_a) {
    var gif = _a.gif, isHovered = _a.isHovered, hideMuteButton = _a.hideMuteButton, width = _a.width, height = _a.height, className = _a.className, _b = _a.muted, userPrefMuted = _b === void 0 ? false : _b, onUserMuted = _a.onUserMuted;
    var _c = react_1.useState(userPrefMuted), muted = _c[0], setMuted = _c[1];
    var _d = react_1.useState(false), mutedByBrowser = _d[0], setMutedByBrowser = _d[1];
    var toggleMute = function () {
        if (mutedByBrowser) {
            setMutedByBrowser(false);
            setMuted(false);
        }
        else {
            onUserMuted === null || onUserMuted === void 0 ? void 0 : onUserMuted(!muted);
            setMuted(!muted);
        }
    };
    react_1.useEffect(function () {
        setMuted(userPrefMuted);
    }, [userPrefMuted, setMuted]);
    var props = { toggleMute: toggleMute, muted: muted, mutedByBrowser: mutedByBrowser };
    return (react_1.default.createElement(VideoContainer, { className: className },
        isHovered && (react_1.default.createElement(VideoStyled, { gif: gif, key: gif.id, loop: true, controls: true, hideAttribution: true, hideMute: true, persistentControls: true, muted: muted, width: width, height: height, onMuted: setMutedByBrowser })),
        !hideMuteButton && react_1.default.createElement(VolumeButton, __assign({}, props, { isHovered: isHovered }))));
};
VideoOverlay.imgClassName = speakerClassName;
exports.default = VideoOverlay;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=video-overlay.js.map